<template>
  <transition name="popup">
    <div class="popup" v-if="isPopupOpen" >
      <div class="popup__wrapper">
        <span class="popup__text">Try not to get scared</span>
        <div class="popup__ok" @click="closePopup">OK</div>
      </div>
    </div>
  </transition>
  <main class="main">
    <h1 class="main__header">$scary</h1>
    <div class="main__container" @click="restartAnimation">
      <h2 class="main__title">Try not to get scared</h2>
      <img class="main__image" src="@/assets/images/creature.webp" alt="creature">
    </div>
    <a href="https://knowyourmeme.com/memes/try-not-to-get-scared-scariest-stories" target="_blank">
      <div class="main__lore">SCARY LORE</div>
    </a>
    <span class="main__ca-section">
      <span class="main__ca">
        ca: ADQeyKAWoLDVnE6Vajnwp9h7wVdzNFosPqQvmEB3pump
      </span>
      <img
          class="main__copy"
          :src="currentIcon"
          alt="copy-icon"
          @click="copyTextToClipboard('ADQeyKAWoLDVnE6Vajnwp9h7wVdzNFosPqQvmEB3pump')">
    </span>
  </main>
  <div class="initial" ref="initial" :class="{'initial--animated' : isAnimating}">
    <span class="initial__title">
    <span
        v-for="(letter, index) in firstLine"
        :key="index"
        class="initial__letter"
        :class="{'initial__letter--animated' : isAnimating}"
        :style="{ animationDelay: `${Math.random() * 0.5}s` }"
    >
      {{ letter }}
    </span>
      <br />
      <span
          v-for="(letter, index) in secondLine"
          :key="`second-${index}`"
          class="initial__letter"
          :class="{'initial__letter--animated' : isAnimating}"
          :style="{ animationDelay: `${Math.random() * 0.5}s` }"
      >
      {{ letter }}
    </span>
    </span>
  </div>
  <a href="https://x.com/ScaryStoriesSol" target="_blank">
    <span class="links__twitter links__link">
      Twitter
    </span>
  </a>
  <a href="https://t.me/ScariestStoriesCTO" target="_blank">
    <span class="links__telegram links__link">
      Telegram
    </span>
  </a>
  <a href="https://dexscreener.com/solana/j2f4ijsmu1rnds9xusw2jb1vm7j64k91cpepwqf7uark" target="_blank">
    <span class="links__dexscreener links__link">
      DexScreener
    </span>
  </a>
  <a href="https://www.tiktok.com/@offlainnnn?_t=8s8PhS63Tq2&_r=1" target="_blank">
    <span class="links__tiktok links__link">
      TikTok
    </span>
  </a>
  <audio ref="musicAudio">
    <source src="../public/sounds/sound.mp3">
  </audio>
</template>

<script setup lang="ts">
import {ref} from "vue";
import copyIcon from '@/assets/icons/copy.svg'
import checkIcon from '@/assets/icons/check.svg'

const isPopupOpen = ref<boolean>(true)
const currentIcon = ref(copyIcon)
const musicAudio = ref<HTMLElement | null>(null)
const initial = ref<HTMLElement | null>(null)
const isAnimating = ref(false);

const firstLine = "SCARIEST".split("");
const secondLine = "STORIES".split("");

const copyTextToClipboard = async (copyText: string): Promise<void> => {
  if (!navigator.clipboard) return;
  try {
    await navigator.clipboard.writeText(copyText)
    currentIcon.value = checkIcon
  } catch (e) {
    console.log(e);
  } finally {
    setTimeout(() => {
      currentIcon.value = copyIcon
    }, 3000)
  }
};
const restartAnimation = () => {
  isAnimating.value = false;
  setTimeout(() => {
    isAnimating.value = true;
  }, 0);
};
const playMusic = () => {
  if (musicAudio.value instanceof HTMLAudioElement) {
    musicAudio.value.play()
  }
}
const closePopup = () => {
  isPopupOpen.value = false
  restartAnimation()
  playMusic()
}
</script>

<style lang="scss">
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}
body {
  overscroll-behavior-y: none;
  background-color: black;
}
#app {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  min-height: 100dvh;
  background-color: black;
  font-family: "Nuosu SIL", sans-serif;
  position: relative;
}
.popup {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.9);
  z-index: 10;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  opacity: 1;
  transition: all 0.3s ease;
  &__wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    background-color: #e1e1e1;
    border-radius: 10px;
    border: 1px solid #ff6363;
    padding: 20px;
    gap: 20px;
  }
  &__text {
    color: black;
    transform: scaleY(1.7);
  }
  &__ok {
    font-family: "Special Elite", system-ui;
    color: #da2626;
    background-color: #ffd87e;
    border: 1px solid #da2626;
    padding: 10px 10px 5px;
    font-size: 1rem;
    cursor: pointer;
    border-radius: 10px;
    box-shadow: 0 0 10px transparent;
    transition: all 0.3s ease;
    &:hover {
      box-shadow: 0 0 10px red;
    }
  }
}
.main {
  width: calc(100vw - 10vw);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  height: calc(100dvh - 10vh);
  margin: 5vh 5vw;
  border-radius: 7vw;
  position: relative;
  background-image: url("@/assets/images/house.png");
  background-size: cover;
  background-position: center;
  box-shadow: inset 0 0 5vh #000000;
  &::before {
    content: '';
    background-image: url("@/assets/images/noise2.png");
    opacity: 0.25;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-repeat: repeat;
    animation: noiseAnimation 0.25s steps(10) infinite;
    border-radius: 7vw;
    pointer-events: none;
    box-shadow: inset 0 0 5vh #000000;
  }
  &__header {
    color: #ffd87e;
    font-family: "Butcherman", system-ui;
    font-size: 5rem;
    text-shadow:
        -0.07vw -0.07vw 0 #da2626,
        0.07vw -0.07vw 0 #da2626,
        -0.07vw 0.07vw 0 #da2626,
        0.07vw 0.07vw 0 #da2626,
        0 0 1vw red;
    line-height: 1.5;
  }
  &__container {
    display: flex;
    flex-direction: column;
    align-items: center;
    background-color: white;
    margin-bottom: 40px;
    box-shadow: 0 0 15px black;
    cursor: pointer;
  }
  &__title{
    font-size: 2rem;
    transform: scaleY(1.7);
  }
  &__image {
    width: 30vw;
    min-width: 200px;
    aspect-ratio: 1;
  }
  &__lore {
    border-radius: 10px;
    font-family: "Special Elite", system-ui;
    color: #da2626;
    margin-bottom: 30px;
    background-color: #ffd87e;
    border: 1px solid #da2626;
    padding: 10px 10px 5px;
    font-size: 1.5rem;
    cursor: pointer;
    &:hover {
      box-shadow: 0 0 10px red;
    }
  }
  &__ca-section {
    font-family: "Special Elite", system-ui;
    font-size: clamp(10px, 0.9vw, 20px);
    color: whitesmoke;
    display: flex;
    align-items: center;
    gap: 5px;
  }
  &__ca {
    transform: scaleY(1.7);
  }
  &__copy {
    cursor: pointer;
    width: 20px;
    aspect-ratio: 1;
    &:hover {
      fill: #ffd87e;
    }
  }
}
.initial {
  pointer-events: none;
  position: absolute;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100dvh;
  overflow: hidden;
  transform-origin: center;
  display: flex;
  justify-content: center;
  align-items: center;
  &--animated {
    animation: text-disappear 1s ease forwards;
    animation-delay: 3s;
  }

  &__title {
    text-align: center;
    font-size: 8vw;
    color: rgb(239, 146, 146);
    text-shadow:
        -0.07vw -0.07vw 0 #da2626,
        0.07vw -0.07vw 0 #da2626,
        -0.07vw 0.07vw 0 #da2626,
        0.07vw 0.07vw 0 #da2626,
        0 0 2vw red;
    line-height: 0.85;
    letter-spacing: 0.6vw;
    transform: scaleY(1.5);
    @media (max-width: 480px) {
      font-size: 15vw;
    }
  }

  &__letter {
    display: inline-block;
    opacity: 0;
    &--animated {
      animation: appear 1.5s ease-out forwards;
    }
  }

  @keyframes appear {
    0% {
      transform: scale(0);
      opacity: 0;
    }
    100% {
      transform: scale(1);
      opacity: 1;
    }
  }

  @keyframes text-disappear {
    0% {
      opacity: 1;
    }
    100% {
      opacity: 0;
    }
  }
}
.links {
  &__link {
    font-family: "Special Elite", system-ui;
    color: white;
    font-size: 1.5rem;
    position: fixed;
    cursor: pointer;
    border-radius: 10px;
    padding: 10px 5px 5px;
    background-color: transparent;
    border: 1px solid transparent;
    box-shadow: 0 0 10px transparent;
    transition: all 0.3s ease;
    &:hover {
      background-color: #d35454;
      box-shadow: 0 0 10px #da2626;
    }
  }
  &__twitter {
    top: 20px;
    left: 20px;
  }
  &__telegram {
    top: 20px;
    right: 20px;
  }
  &__dexscreener {
    bottom: 20px;
    right: 20px;
  }
  &__tiktok {
    bottom: 20px;
    left: 20px;
  }
  @media (max-width: 480px) {
    &__twitter {
      top: 10px;
      left: 10px;
    }
    &__telegram {
      top: 10px;
      right: 10px;
    }
    &__dexscreener {
      bottom: 10px;
      right: 10px;
    }
    &__tiktok {
      bottom: 10px;
      left: 10px;
    }
  }
}
@keyframes noiseAnimation {
  0% {
    background-position: 0 0;
  }
  5% {
    background-position: 5% 2%;
  }
  10% {
    background-position: -5% -10%;
  }
  15% {
    background-position: -3% 10%;
  }
  20% {
    background-position: -10% 5%;
  }
  25% {
    background-position: 8% -8%;
  }
  30% {
    background-position: 7% -25%;
  }
  35% {
    background-position: -6% 15%;
  }
  40% {
    background-position: -20% 20%;
  }
  45% {
    background-position: 10% -10%;
  }
  50% {
    background-position: 15% -15%;
  }
  55% {
    background-position: 0 7%;
  }
  60% {
    background-position: 0 15%;
  }
  65% {
    background-position: -8% 0;
  }
  70% {
    background-position: -25% 10%;
  }
  75% {
    background-position: 5% 5%;
  }
  80% {
    background-position: 20% 0;
  }
  85% {
    background-position: -10% 8%;
  }
  90% {
    background-position: 10% 5%;
  }
  95% {
    background-position: 15% 0;
  }
  100% {
    background-position: 0 0;
  }
}
a {
  text-decoration: none;
}
.popup-enter-from, .popup-leave-to {
  transition: all 0.3s ease;
  opacity: 0;
}
</style>
